export default __webpack_public_path__ + "static/birb-ab8a465ed0ab91684020cf95f820a5dc.png";